// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__lUXUp","rightContainer":"Dashboard_rightContainer__BpDwe"};